"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BringgDashboardSDK_1 = require("../../BringgDashboardSDK");
var object_merger_1 = require("../../Data/object-merger");
var data_entity_1 = require("../../data-entity");
var data_store_1 = __importDefault(require("../../data-store"));
var storable_data_service_1 = __importDefault(require("../../storable-data-service"));
var runs_consts_1 = require("../runs.consts");
var runs_service_1 = require("../Service/runs.service");
var run_realtime_subscriptions_1 = __importDefault(require("./run-realtime-subscriptions"));
var RunsApi = /** @class */ (function () {
    function RunsApi(session) {
        var _this = this;
        this.onUpdate = function (callback) {
            return _this.realtimeSubscriptions.onUpdate(callback);
        };
        this.onDelete = function (callback) {
            return _this.realtimeSubscriptions.onDelete(callback);
        };
        this.onCreate = function (callback) {
            return _this.realtimeSubscriptions.onCreate(callback);
        };
        this.runsStore = new data_store_1.default([
            {
                groupType: runs_consts_1.RunGroupTypes.TaskIds,
                keyFunc: function (runModel) { return runModel.task_ids; }
            }
        ]);
        this.runsService = new runs_service_1.RunsService(session);
        var mapper = function (run, params) {
            var existing = _this.runsStore.get(run.id);
            var taskIds;
            if (params.taskIds || run.task_ids || run.tasks) {
                taskIds = params.taskIds || run.task_ids || run.tasks.map(function (task) { return task.id; });
            }
            if (existing) {
                var previous = (0, BringgDashboardSDK_1.getGlobals)().mobx.toJS(existing);
                run.task_ids = taskIds || existing.task_ids;
                var diff = object_merger_1.objectMerger.deepMerge(previous, run);
                return { current: run, diff: diff };
            }
            else {
                run.task_ids = taskIds || [];
                return { current: run };
            }
        };
        this.storableDataService = new storable_data_service_1.default(this.runsStore, mapper);
        this.realtimeSubscriptions = new run_realtime_subscriptions_1.default(session, this.runsStore, this.storableDataService);
    }
    RunsApi.prototype.updateStoreOnEvents = function () {
        this.realtimeSubscriptions.updateStoreOnEvents();
    };
    RunsApi.prototype.get = function (id) {
        return this.runsStore.get(id);
    };
    RunsApi.prototype.getAll = function () {
        return this.runsStore.getAll();
    };
    RunsApi.prototype.getAllMap = function () {
        return this.runsStore.getAllById();
    };
    RunsApi.prototype.getByIds = function (ids) {
        var _this = this;
        return ids.map(function (runId) { return _this.runsStore.get(runId); }).filter(Boolean);
    };
    RunsApi.prototype.add = function (run) {
        return this.storableDataService.updateInStores(run);
    };
    RunsApi.prototype.remove = function (id) {
        return this.storableDataService.removeFromStores(id);
    };
    RunsApi.prototype.loadMany = function (queryParams, options, commonOptions) {
        if (options === void 0) { options = data_entity_1.DEFAULT_OPTIONS; }
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.storableDataService.loadMany('loadMany', function (idsToLoad) {
                        return _this.runsService.loadAll(__assign(__assign({}, queryParams), { ids: queryParams.ids && idsToLoad }), commonOptions);
                    }, queryParams.ids || [], options)];
            });
        });
    };
    RunsApi.prototype.loadRunsData = function (payload, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.loadRunsData(payload, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RunsApi.prototype.load = function (id, options) {
        var _this = this;
        if (options === void 0) { options = data_entity_1.DEFAULT_OPTIONS; }
        return this.storableDataService.load('load', function () { return _this.runsService.load(id); }, id, options);
    };
    RunsApi.prototype.update = function (id, options, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.storableDataService.modify('update', function () { return _this.runsService.update(id, options, commonOptions); })];
            });
        });
    };
    RunsApi.prototype.getHistory = function (id, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.getHistory(id, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RunsApi.prototype.getLocations = function (id, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.getLocations(id, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RunsApi.prototype.getCashout = function (id, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.getCashout(id, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RunsApi.prototype.assignDriver = function (id, userId, targetRun, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.assignDriver(id, userId, targetRun, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RunsApi.prototype.unassignDriver = function (id, userId, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.unassignDriver(id, userId, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RunsApi.prototype.assignVehicles = function (id, vehicleId, tasks, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.assignVehicles(id, vehicleId, tasks, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RunsApi.prototype.unassignVehicles = function (id, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.unassignVehicles(id, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RunsApi.prototype.bulkClose = function (runIds, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.bulkClose(runIds, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RunsApi.prototype.markDonePlanning = function (runIds, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.markDonePlanning(runIds, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RunsApi.prototype.getActualBreaks = function (runIds, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.runsService.getActualBreaks(runIds, commonOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return RunsApi;
}());
exports.default = RunsApi;
//# sourceMappingURL=runs-api.js.map